import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c3aba9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "portfolio-item"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "date" }
const _hoisted_6 = ["href", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (
      _ctx.selectedCategory === 'all' || _ctx.selectedCategory === _ctx.portfolioItem.category
    )
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          src: _ctx.getImgUrl(_ctx.portfolioItem.img, 'jpg'),
          alt: "{{$t(portfolioItem.alt)}}"
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.portfolioItem.name), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t(_ctx.portfolioItem.description)), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.portfolioItem.date), 1),
          _createElementVNode("a", {
            class: "link",
            href: _ctx.portfolioItem.link,
            title: _ctx.portfolioItem.name
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-link" })
          ], 8, _hoisted_6)
        ])
      ]))
    : _createCommentVNode("", true)
}